import { createContext } from 'react';

export const StepShellContext = createContext<{ userName?: string }>({});
